var map = {
	"./1-active.png": "sCrr",
	"./1.png": "kEHQ",
	"./2-active.png": "WDG3",
	"./2.png": "VBpZ",
	"./3-active.png": "rLip",
	"./3.png": "ZNlh",
	"./bg.png": "NLbk",
	"./copy-right.png": "WSD+",
	"./custom-bullet-active.png": "i9CL",
	"./custom-bullet.png": "aita",
	"./img-border.png": "rd/L",
	"./nav-1-title.png": "XOqF",
	"./nav-3/1.png": "+VMp",
	"./nav-3/2.png": "s26A",
	"./nav-3/3.png": "Gj4U",
	"./nav-3/4.png": "xUgL",
	"./nav-3/5.png": "0Hcm",
	"./next.png": "J5x9",
	"./prev.png": "2UCg",
	"./title.png": "+ygy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BxNV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5 ^\.\/.*\.png$
// module id = BxNV
// module chunks = 0